import React from "react";
import { cn } from "../lib/utils";

/**
 * Smartorange wordmark. The SVG's wordmark glyphs are white (for the dark UI);
 * on the light theme we swap to a dark-wordmark variant so it stays legible.
 * Both <img>s render; CSS shows exactly one per theme (default/dark -> white,
 * .light -> dark). Keeps the orange mark identical in both.
 */
const BrandLogo = ({ className, alt = "Smartorange" }) => (
  <>
    <img src="/smartorange-logo.svg" alt={alt} className={cn(className, "light:hidden")} />
    <img src="/smartorange-logo-light.svg" alt={alt} className={cn(className, "hidden light:block")} />
  </>
);

export default BrandLogo;
